import * as z from "zod/v4";
import { hsaSessionState } from "./types";

export const advanceHsaGroupInput = z.object({
  sessionToken: z.string().uuid(),
  // Defensive guard: the client states what group it thinks it just
  // finished, so the server can detect a stale advance (e.g. reload-
  // then-advance after the walker has already moved past). For v1 the
  // server just compares; mismatch responses are out of scope.
  currentGroupHandle: z.string().min(1),
});

export const advanceHsaGroupOutput = z.object({ state: hsaSessionState });
